import { PROFILE_ERROR, PROFILE_SUCCESS, EDIT_PROFILE, VIEW_PROFILE, RESET_PROFILE_FLAG, PASSWORD_CHANGE } from "./actionTypes"

export const viewProfile = (url, callback) => {
  return {
    type: VIEW_PROFILE,
    payload: { url, callback },
  }
}

export const editProfile = (user, url, callback) => {
  return {
    type: EDIT_PROFILE,
    payload: { user, url, callback },
  }
}

export const passwordChange = (data, url, callback) => {
  return {
    type: PASSWORD_CHANGE,
    payload: { data, url, callback },
  }
}

export const profileSuccess = msg => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = error => {
  return {
    type: RESET_PROFILE_FLAG,
  }
}
